import { Button, ButtonGroup } from '@material-ui/core';
import React from 'react';
import { PlusIcon } from '../../../icons';

function FilterLineEnd({ open, disabled, onClick, anchorRef }) {
    return (
        <ButtonGroup size="small" disableFocusRipple disableRipple className="searchfilter">
            <Button
                size="small"
                disabled={disabled}
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={onClick}
            >
                <PlusIcon style={{ fontSize: '80%' }} />
            </Button>
        </ButtonGroup>
    );
}
export default FilterLineEnd;
